import React, { useState, useEffect } from "react";
import useSendCollectionCodeEmailMutation from "../hooks/useSendCollectionCodeEmailMutation";
import DSTextField from "../../system-design/DSTextField";
import DSDialog from "../../system-design/DSDialog";
import DSDialogTitle from "../../system-design/DSDialogTitle";
import DSDialogContent from "../../system-design/DSDialogContent";
import DSDialogActions from "../../system-design/DSDialogActions";
import DSPrimaryButton from "../../system-design/DSPrimaryButton";
import DSSecondaryButton from "../../system-design/DSSecondaryButton";

interface SendCollectionCodeEmailModalProps {
  show: boolean;
  codeId: string | null;
  onClose: () => void;
}

const SendCollectionCodeEmailModal: React.FC<
  SendCollectionCodeEmailModalProps
> = ({ show, codeId, onClose }) => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const { mutate: sendEmail, isPending: isSending } =
    useSendCollectionCodeEmailMutation();

  useEffect(() => {
    if (!show) {
      setEmail("");
      setEmailError("");
    }
  }, [show]);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSend = () => {
    if (!email) {
      setEmailError("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    if (!codeId) return;

    setEmailError("");
    sendEmail(
      { codeId, email },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <DSDialog open={show} onClose={onClose} fullWidth maxWidth="sm">
      <DSDialogTitle>Send Collection Code</DSDialogTitle>
      <DSDialogContent>
        <DSTextField
          fullWidth
          type="email"
          label="Email Address"
          placeholder="Enter email address"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setEmailError("");
          }}
          error={!!emailError}
          helperText={emailError}
          sx={{ mt: 1 }}
        />
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={onClose} disabled={isSending}>
          Cancel
        </DSSecondaryButton>
        <DSPrimaryButton onClick={handleSend} disabled={isSending}>
          {isSending ? "Sending..." : "Send Email"}
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default SendCollectionCodeEmailModal;
